import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { ProcessStepFromQuoteRequestLine } from "#modules/similarPart/view/clustering/CompareCard";
import { ProcessStepActionIcon } from "#modules/similarPart/view/clustering/ProcessStepActionIcon";
import { normalizeProductLines } from "#shared/helpers/normalizeProductLines";
import { Flex } from "#shared/view/components/Flex";
import { getProcessStepTitle } from "#shared/view/components/Form/getProcessStepTitle";
import { Text } from "#shared/view/components/Text";
import { computeProcessPrice, formatPrice, NO_OPTIMIZED_MACHINE_TIMES } from "shared";

import { useExcludedProcessStepsActions } from "./useExcludedProcessStepsActions";

export const CompareProcessStepLine = ({
  processStep,
  targetQuoteRequestLine,
  sourceQuoteRequestLine,
}: {
  processStep: ProcessStepFromQuoteRequestLine;
  targetQuoteRequestLine: QuoteRequestLineDto;
  sourceQuoteRequestLine: QuoteRequestLineDto;
}) => {
  const [excludedProcessSteps, { excludeProcessStep, includeProcessStep }] =
    useExcludedProcessStepsActions({ sourceQuoteRequestLine });

  const processStepPrice = (): number => {
    const normalizedProductLines = normalizeProductLines({
      productLines: processStep.productLines,
      quoteRequestLineQuantity: targetQuoteRequestLine.quantity,
    });

    return computeProcessPrice({
      quantity: sourceQuoteRequestLine.quantity,
      reworkRatio: targetQuoteRequestLine.reworkRatio,
      quantityInAssembly: targetQuoteRequestLine.part.quantityInAssembly,
      processStep: {
        ...processStep,
        productLines: normalizedProductLines,
      },
      optimizedMachineTimes: NO_OPTIMIZED_MACHINE_TIMES,
    }).partProcessCost;
  };

  const isExcluded = excludedProcessSteps
    .map((excludedProcessStep) => excludedProcessStep.id)
    .includes(processStep.id);

  return (
    <Flex key={processStep.id} gap="xs" justify={"space-between"} align={"center"}>
      <Flex gap="xs" align={"center"}>
        <ProcessStepActionIcon
          processStep={processStep}
          isExcluded={isExcluded}
          excludeProcessStep={excludeProcessStep}
          includeProcessStep={includeProcessStep}
        />

        <Text fz="xs" td={isExcluded ? "line-through" : ""}>
          {getProcessStepTitle({
            processStep,
            companyMachine: undefined,
            materialGrade: targetQuoteRequestLine.materialGrade,
          })}
        </Text>
      </Flex>

      <Text fz="xs">{formatPrice(processStepPrice())}</Text>
    </Flex>
  );
};
